export default "__VITE_ASSET__7647a0ae__"